import Lottie from "react-lottie-player";
import animationJson from "./animation.json";

const SportsbetLoad = () => (
  <Lottie
    animationData={animationJson}
    play
    loop
    style={{ width: 120, height: 120 }}
  />
);

export default SportsbetLoad;
